import { format, isBefore } from 'date-fns';

import { AbstractControl, ValidationErrors } from '@angular/forms';

import { ApValidDateValidator } from './valid-date.validator';

export class ApMinDateValidator {
    /**
     * Validate that passed date is not before minDate.
     */
    public static validate(minDate: Date): (control: AbstractControl) => ValidationErrors | null {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) {
                return null;
            }

            /**
             * This validator does not validate if the date is valid
             * If date is not valid at all no error from the minDate validator
             */
            if (!ApValidDateValidator.isValid(control.value)) {
                return null;
            }

            return isBefore(control.value, minDate) ? { minDate: { minDate: format(minDate, 'dd-MM-yyyy'), value: control.value } } : null;
        };
    }
}
